module.exports = __webpack_public_path__ + "img/content8.92451551.png";